import React, { Suspense } from 'react';

import { isServer } from 'js/helpers/environment';

import { Props } from './SimpleMap';

const Map = React.lazy(() => import('./SimpleMap'));

/*
  This component wraps another component that renders
  a map using the leaflet library.

  Unfortunately leaflet accesses the window object during
  its auto-initialisation. This means that it must not
  be imported and initialised during server rendering
  (even though its API wouldn't be used there).

  So the wrapped component is lazily loaded in the browser.
  This leaves the wrapped component free to import and use
  leaflet in the normal manner.
*/
export function MapPopup(props: Props): React.ReactElement | null {
  if (isServer) {
    return null;
  }

  return (
    <Suspense fallback={<div />}>
      <Map {...props} />
    </Suspense>
  );
}
